import {
  Button,
  CircularProgress,
  // IconButton,
  Paper,
  //  Tooltip,
  Typography,
} from "@mui/material";
import { CustomFormField } from "../../../../../utilis/component/CustomFormElement";
import { useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import { useMutation } from "react-query";
import {
  getSecondMedicalHistory,
  saveSecondMedicalHistory,
} from "../../../../services";
import usePopup from "../../../../../hooks/usePopup";
import { useEffect, useRef, useState } from "react";
import LogComonent from "../../../layouts/LogComonent";

const isYes = (value: unknown) => value === true || value === "true";

const detailRequired = (detailField: string) => (value: unknown, formValues: Record<string, unknown>) => {
  if (!isYes(formValues[detailField])) return true;
  return String(value ?? "").trim() ? true : "This field is required";
};

const toRadioValue = (value: unknown) => {
  if (value === true || value === "true") return "true";
  if (value === false || value === "false") return "false";
  return "";
};
// import ListAltIcon from "@mui/icons-material/ListAlt";
// import MedicalHistoryLog from "./MedicalHistoryLog";
function MedicalHistorySecond() {
  const { encounterId } = useParams();
  const {
    showSnackbar,
    // CustomModal
  } = usePopup();
  // const [open,setOpen] = useState<boolean>(false)
  const { control, handleSubmit, reset, setValue, watch } = useForm();
  const takingMedication = watch("takingAnyMedicationLastSixMonths");
  const receivingTreatment = watch("areYouReceiveAnyTreatment");
  const chronicDiseases = watch("accuteOrChronicDiseases");
  const prevRadioValuesRef = useRef<Record<string, unknown>>({});
  const [recordId, setRecordId] = useState<number | null>(null);
  const { mutate: save, isLoading: saveLOading } = useMutation(
    saveSecondMedicalHistory,
    {
      onSuccess: (result) => {
        if (result.responseIndicator == "success") {
          const savedId = result.response?.id;
          if (savedId != null) {
            setRecordId(Number(savedId));
          }
          showSnackbar({
            message: "Saved successfully !",
            open: true,
            variant: "success",
            duration: 2000,
          });
        } else {
          showSnackbar({
            message: "Failed !",
            open: true,
            variant: "warning",
            duration: 2000,
          });
        }
      },
      onError: () => {
        showSnackbar({
          message: "Something went wrong !",
          open: true,
          variant: "warning",
          duration: 2000,
        });
      },
    },
  );

  useEffect(() => {
    const pairs = [
      {
        radio: "takingAnyMedicationLastSixMonths",
        detail: "medDetails",
        value: takingMedication,
      },
      {
        radio: "areYouReceiveAnyTreatment",
        detail: "treatDetails",
        value: receivingTreatment,
      },
      {
        radio: "accuteOrChronicDiseases",
        detail: "chronicDetails",
        value: chronicDiseases,
      },
    ];

    pairs.forEach(({ radio, detail, value }) => {
      const previousValue = prevRadioValuesRef.current[radio];

      if (previousValue !== undefined && !isYes(value) && isYes(previousValue)) {
        setValue(detail, "", { shouldValidate: true });
      }

      prevRadioValuesRef.current[radio] = value;
    });
  }, [takingMedication, receivingTreatment, chronicDiseases, setValue]);

  const { mutate: fetchData } = useMutation(getSecondMedicalHistory, {
    onSuccess: (result) => {
      if (result.responseIndicator == "success") {
        setRecordId(result.response?.id ?? null);
        reset({
          ...result.response,
          takingAnyMedicationLastSixMonths: toRadioValue(
            result.response?.takingAnyMedicationLastSixMonths,
          ),
          areYouReceiveAnyTreatment: toRadioValue(
            result.response?.areYouReceiveAnyTreatment,
          ),
          accuteOrChronicDiseases: toRadioValue(
            result.response?.accuteOrChronicDiseases,
          ),
          areYouTakingBirthControlPills: toRadioValue(
            result.response?.areYouTakingBirthControlPills,
          ),
          areYouPregnant: toRadioValue(result.response?.areYouPregnant),
          breastFeeding: toRadioValue(result.response?.breastFeeding),
        });
        prevRadioValuesRef.current = {
          takingAnyMedicationLastSixMonths: toRadioValue(
            result.response?.takingAnyMedicationLastSixMonths,
          ),
          areYouReceiveAnyTreatment: toRadioValue(
            result.response?.areYouReceiveAnyTreatment,
          ),
          accuteOrChronicDiseases: toRadioValue(
            result.response?.accuteOrChronicDiseases,
          ),
        };
      }
    },
  });

  const onSubmit = (value: any) => {
    for (let key in value) {
      if (value[key] == "true" || value[key] == "false") {
        value[key] = value[key] == "true";
      }
    }
    const params = {
      ...value,
      encounterId: parseInt(encounterId as string),
      ...(recordId != null ? { id: recordId } : {}),
    };
    for(let key in params){
      if(params[key] == undefined){
        delete params[key]
      }
    }
    save(params);
  };

  useEffect(() => {
    fetchData(encounterId as string);
  }, []);
  return (
    <Paper>
      {/* <CustomModal title="Medical history log" open={open} setOpen={setOpen}>
        <MedicalHistoryLog />
      </CustomModal> */}
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="grid grid-cols-2 gap-x-2 gap-y-3 p-2"
      >
        <div className="col-span-full flex justify-between">
          <Typography fontWeight={600}>Medical History</Typography>
          {/* <Tooltip title="Medical history log">
          <IconButton color="primary" onClick={()=>{setOpen(true)}}>
            <ListAltIcon/>
          </IconButton>
          </Tooltip> */}
          <LogComonent title="Medical history" field="medicalhistory" />
        </div>

        <div className="border-2 p-2 rounded flex flex-col gap-y-3 justify-between">
          <Typography>Taking any medication in Last Six months</Typography>
          <CustomFormField
            control={control}
            name="takingAnyMedicationLastSixMonths"
            element="radio"
            fieldProps={{ label: "" }}
            radios={radioFields}
            rules={{ required: "Required" }}
            radioProps={{ row: true }}
          />

          <div
            className={
              isYes(takingMedication) ? "block" : "hidden"
            }
          >
            <CustomFormField
              control={control}
              name="medDetails"
              element="input"
              fieldProps={{
                label: "Medication details",
                multiline: true,
              }}
              rules={{
                validate: detailRequired("takingAnyMedicationLastSixMonths"),
              }}
              radioProps={{ row: true }}
            />
          </div>
        </div>

        <div className="border-2 p-2 rounded flex flex-col gap-y-3 justify-between">
          <Typography>Are you receiving any treatment </Typography>
          <CustomFormField
            control={control}
            name="areYouReceiveAnyTreatment"
            element="radio"
            fieldProps={{ label: "" }}
            radios={radioFields}
            rules={{ required: "Required" }}
            radioProps={{ row: true }}
          />
          <div
            className={
              isYes(receivingTreatment) ? "block" : "hidden"
            }
          >
            <CustomFormField
              control={control}
              name="treatDetails"
              element="input"
              fieldProps={{
                label: "Treatment details",
                multiline: true,
              }}
              rules={{
                validate: detailRequired("areYouReceiveAnyTreatment"),
              }}
              radioProps={{ row: true }}
            />
          </div>
        </div>

        <div className="border-2 p-2 rounded flex flex-col gap-y-3 justify-between">
          <Typography>Details of acute or chronic disease </Typography>
          <CustomFormField
            control={control}
            name="accuteOrChronicDiseases"
            element="radio"
            fieldProps={{ label: "" }}
            radios={radioFields}
            rules={{ required: false }}
            radioProps={{ row: true }}
          />
          <div
            className={isYes(chronicDiseases) ? "block" : "hidden"}
          >
            <CustomFormField
              control={control}
              name="chronicDetails"
              element="input"
              fieldProps={{
                label: "Disease details",
                multiline: true,
              }}
              rules={{
                validate: detailRequired("accuteOrChronicDiseases"),
              }}
              radioProps={{ row: true }}
            />
          </div>
        </div>
        <div className="border-2 p-2 rounded flex flex-col gap-y-3 justify-between">
          <Typography>Are you taking birth control pills :</Typography>
          <CustomFormField
            control={control}
            name="areYouTakingBirthControlPills"
            element="radio"
            fieldProps={{ label: "" }}
            radios={radioFields}
            rules={{ required: false }}
            radioProps={{ row: true }}
          />
        </div>
        <div className="border-2 p-2 rounded flex flex-col gap-y-3 justify-between">
          <Typography>Are you pregnant </Typography>
          <CustomFormField
            control={control}
            name="areYouPregnant"
            element="radio"
            fieldProps={{ label: "" }}
            radios={radioFields}
            rules={{ required: false }}
            radioProps={{ row: true }}
          />
        </div>
        <div className="border-2 p-2 rounded flex flex-col gap-y-3 justify-between">
          <Typography>Breast feeding</Typography>
          <CustomFormField
            control={control}
            name="breastFeeding"
            element="radio"
            fieldProps={{ label: "" }}
            radios={radioFields}
            rules={{ required: false }}
            radioProps={{ row: true }}
          />
        </div>
        <div className="border-2 p-2 rounded flex flex-col gap-y-3 justify-between">
          <Typography>Chronic Medication</Typography>
          <CustomFormField
            control={control}
            name="medicationForChronicDisease"
            element="input"
            fieldProps={{ label: "Medication for chronic disease" }}
            rules={{ required: false }}
            radioProps={{ row: true }}
          />
        </div>
        <div className="border-2 p-2 rounded flex flex-col gap-y-3 justify-between">
          <Typography>Past Surgery details</Typography>
          <CustomFormField
            control={control}
            name="pastSurguryDetails"
            element="input"
            fieldProps={{ label: "Details of past surgeries" }}
            rules={{ required: false }}
            radioProps={{ row: true }}
          />
        </div>
        <div className="border-2 p-2 rounded flex flex-col gap-y-3 justify-between">
          <Typography>Any medicine other than in prescription</Typography>
          <CustomFormField
            control={control}
            name="anyMedicineShouldNotBeInPrescription"
            element="input"
            fieldProps={{ label: "Medication restrictions" }}
            rules={{ required: false }}
            radioProps={{ row: true }}
          />
        </div>
        <div className="border-2 p-2 rounded flex flex-col gap-y-3 justify-between">
          <Typography>Others</Typography>
          <CustomFormField
            control={control}
            name="others"
            element="input"
            fieldProps={{ label: "Other relevant information" }}
            rules={{ required: false }}
            radioProps={{ row: true }}
          />
        </div>
        <div className="col-span-full flex justify-end items-center">
          <Button
            type="submit"
            disabled={saveLOading}
            endIcon={saveLOading && <CircularProgress size={18} />}
          >
            save details
          </Button>
        </div>
      </form>
    </Paper>
  );
}

export default MedicalHistorySecond;
const radioFields = [
  {
    label: "Yes",
    value: "true",
  },
  {
    label: "No",
    value: "false",
  },
];
